import { useMemo } from 'react';
import { Box } from 'theme-ui';
import { useSettings, useRouter } from '@backpackjs/storefront';

import { Markdown } from '@snippets';

import { themed } from './SeoFooter.theme';

export const SeoFooter = themed(({ theme }) => {
  const router = useRouter();
  const settings = useSettings();
  const groups = settings?.collection?.seo?.groups;
  const handle = router.query?.handle;

  const seoText = useMemo(() => {
    if (!groups?.length) return null;
    const group = groups.find(({ collections }) => {
      return collections?.includes(handle);
    });
    return group?.body || null;
  }, [JSON.stringify(groups), handle]);

  return seoText ? (
    <Box data-comp={SeoFooter.displayName} sx={{ gridArea: 'footer' }}>
      <Markdown
        text={seoText}
        textSx={{
          variant: 'text.base',
          fontSize: [3, 4],
          lineHeight: [20, 22],
        }}
      />
    </Box>
  ) : null;
});

SeoFooter.displayName = 'SeoFooter';
